module.exports = __webpack_public_path__ + "static/media/search-caret.6a1ffc5b.svg";